/**
 * @generated SignedSource<<a0877db10ec3565141a11ea6ddaabfbe>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type OrderStatusType = "ClosedByAdmin" | "HasBillingDetails" | "HasCart" | "HasPaymentDetails" | "PaymentInProcess" | "PaymentReceived" | "Purchased" | "PurchasedAwaitingAccount" | "Transient";
export type CloseOrderInput = {
  clientMutationId?: string | null;
  orderId: string;
  reason: string;
};
export type closeOrderAction_CloseOrderMutation$variables = {
  input: CloseOrderInput;
};
export type closeOrderAction_CloseOrderMutation$data = {
  readonly Admin: {
    readonly Billing: {
      readonly closeOrder: {
        readonly clientMutationId: string | null;
        readonly order: {
          readonly history: {
            readonly " $fragmentSpreads": FragmentRefs<"orderHistoryTable_OrderHistoryFragment">;
          } | null;
          readonly id: string;
          readonly status: OrderStatusType;
        };
      } | null;
    };
  };
};
export type closeOrderAction_CloseOrderMutation = {
  response: closeOrderAction_CloseOrderMutation$data;
  variables: closeOrderAction_CloseOrderMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "kind",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "clientMutationId",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "invoiceNumber",
  "storageKey": null
},
v8 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "email",
    "storageKey": null
  },
  (v2/*: any*/)
],
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sentToInvoiceEmail",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sentByUserId",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "sentBy",
  "plural": false,
  "selections": (v8/*: any*/),
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "closeOrderAction_CloseOrderMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminMutationType",
        "kind": "LinkedField",
        "name": "Admin",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "BillingAdminMutationSchema",
            "kind": "LinkedField",
            "name": "Billing",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v1/*: any*/),
                "concreteType": "CloseOrderPayload",
                "kind": "LinkedField",
                "name": "closeOrder",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Order",
                    "kind": "LinkedField",
                    "name": "order",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v3/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "OrderHistory",
                        "kind": "LinkedField",
                        "name": "history",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "InlineDataFragmentSpread",
                            "name": "orderHistoryTable_OrderHistoryFragment",
                            "selections": [
                              (v2/*: any*/),
                              (v4/*: any*/),
                              (v3/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "event",
                                "plural": true,
                                "selections": [
                                  (v5/*: any*/),
                                  {
                                    "args": null,
                                    "kind": "FragmentSpread",
                                    "name": "orderHistoryEvent_OrderHistoryFragment"
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "args": null,
                            "argumentDefinitions": []
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v6/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "closeOrderAction_CloseOrderMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminMutationType",
        "kind": "LinkedField",
        "name": "Admin",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "BillingAdminMutationSchema",
            "kind": "LinkedField",
            "name": "Billing",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v1/*: any*/),
                "concreteType": "CloseOrderPayload",
                "kind": "LinkedField",
                "name": "closeOrder",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Order",
                    "kind": "LinkedField",
                    "name": "order",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v3/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "OrderHistory",
                        "kind": "LinkedField",
                        "name": "history",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          (v4/*: any*/),
                          (v3/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "event",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "__typename",
                                "storageKey": null
                              },
                              (v5/*: any*/),
                              {
                                "kind": "TypeDiscriminator",
                                "abstractKey": "__isHistoryEvent"
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "when",
                                "storageKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "invoiceId",
                                    "storageKey": null
                                  },
                                  (v7/*: any*/)
                                ],
                                "type": "InvoiceSentEvent",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "previousInvoiceEmail",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "newInvoiceEmail",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "correctedByUserId",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "User",
                                    "kind": "LinkedField",
                                    "name": "correctedBy",
                                    "plural": false,
                                    "selections": (v8/*: any*/),
                                    "storageKey": null
                                  }
                                ],
                                "type": "InvoiceEmailCorrectedEvent",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v9/*: any*/),
                                  (v10/*: any*/),
                                  (v11/*: any*/)
                                ],
                                "type": "ClaimEmailResentEvent",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v7/*: any*/),
                                  (v9/*: any*/),
                                  (v10/*: any*/),
                                  (v11/*: any*/)
                                ],
                                "type": "InvoiceResentEvent",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "reason",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "closedByUserId",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "User",
                                    "kind": "LinkedField",
                                    "name": "closedBy",
                                    "plural": false,
                                    "selections": (v8/*: any*/),
                                    "storageKey": null
                                  }
                                ],
                                "type": "OrderClosedByAdminEvent",
                                "abstractKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v6/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "82c18a11f0068702df06cba04d729d87",
    "id": null,
    "metadata": {},
    "name": "closeOrderAction_CloseOrderMutation",
    "operationKind": "mutation",
    "text": "mutation closeOrderAction_CloseOrderMutation(\n  $input: CloseOrderInput!\n) {\n  Admin {\n    Billing {\n      closeOrder(input: $input) {\n        order {\n          id\n          status\n          history {\n            ...orderHistoryTable_OrderHistoryFragment\n            id\n          }\n        }\n        clientMutationId\n      }\n    }\n  }\n}\n\nfragment orderHistoryEvent_OrderHistoryFragment on HistoryEvent {\n  __isHistoryEvent: __typename\n  kind\n  when\n  ... on InvoiceSentEvent {\n    invoiceId\n    invoiceNumber\n  }\n  ... on InvoiceEmailCorrectedEvent {\n    previousInvoiceEmail\n    newInvoiceEmail\n    correctedByUserId\n    correctedBy {\n      name\n      email\n      id\n    }\n  }\n  ... on ClaimEmailResentEvent {\n    sentToInvoiceEmail\n    sentByUserId\n    sentBy {\n      name\n      email\n      id\n    }\n  }\n  ... on InvoiceResentEvent {\n    invoiceNumber\n    sentToInvoiceEmail\n    sentByUserId\n    sentBy {\n      name\n      email\n      id\n    }\n  }\n  ... on OrderClosedByAdminEvent {\n    reason\n    closedByUserId\n    closedBy {\n      name\n      email\n      id\n    }\n  }\n}\n\nfragment orderHistoryTable_OrderHistoryFragment on OrderHistory {\n  id\n  createdAt\n  status\n  event {\n    __typename\n    kind\n    ...orderHistoryEvent_OrderHistoryFragment\n  }\n}\n"
  }
};
})();

(node as any).hash = "288dda95090c6f386c342949904c2edc";

export default node;
